/* eslint-disable react-hooks/rules-of-hooks */
import { FC } from "react";
import { useHistory } from "react-router-dom";
import { faGhost } from "@fortawesome/pro-duotone-svg-icons";
import { Button, Text } from "@mantine/core";

import { IssueType } from "@protos/issues/v1/issues";
import { Billboard } from "@shared/components";
import { useBasePath, useOrg, useSupportsFeature } from "@shared/hooks";

const HREF_MAP: Record<IssueType, string> = {
  [IssueType.SCA]: "/supply-chain",
  [IssueType.SAST]: "/findings",
  [IssueType.SECRETS]: "/secrets",
  [IssueType.RESEARCH]: "",
  [IssueType.UNSPECIFIED]: "",
};

interface FindingNotFoundProps {
  issueType: IssueType;
}

export const FindingNotFound: FC<FindingNotFoundProps> = ({ issueType }) => {
  const [org] = useOrg();
  const basePath = useBasePath();
  const history = useHistory();
  const hasPrimaryBranchCapabilities = useSupportsFeature(
    "hasPrimaryBranchCapabilities"
  );

  const primaryAction = (
    <Button
      onClick={() =>
        history.push(
          `${basePath}${HREF_MAP[issueType]}${
            hasPrimaryBranchCapabilities ? "?primary=true" : ""
          }`
        )
      }
      variant="outline"
    >
      Back to {org && `${org.name} `}findings
    </Button>
  );

  return (
    <Billboard
      icon={faGhost}
      title="Finding Not Accessible"
      primaryAction={primaryAction}
    >
      <Text size="sm" c="gray.6">
        The link to this finding may be incorrect, or it may be in a different
        organization.
      </Text>
      <Text size="sm" c="gray.6">
        Change your organization using the selector in the upper left.
      </Text>
    </Billboard>
  );
};
